import { css } from '@emotion/css'
import { spacing, shorthandHelper, colors } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    flexDirection: 'column',
    marginBottom: spacing.medium,
  }),

  header: css({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: shorthandHelper([spacing.default, spacing.default, spacing.default, spacing.medium]),
    borderBottom: `1px solid ${colors.geyser}`,
  }),

  check: css({
    position: 'absolute',
    left: -12,
    top: '50%',
    transform: 'translateY(-50%)',
  }),

  body: css({
    display: 'flex',
    padding: spacing.medium,
  }),
}

export default styles
